export enum CommentType {
  Question = 'dealcomment',
  Review = 'dealreview',
}

export enum ApprovalStatus {
  Denied,
  Approved,
  Unapproved,
}

export enum ModerationStatus {
  Unresolved,
  Resolved,
}

export enum UserStatus {
  Whitelist = 'whitelist',
  Blacklist = 'blacklist',
}
